import useSWR from 'swr';
import queryString from 'query-string';
import type { SwrReturnType } from '~/models/Api';
import type { ConstructionItemSettingEdit } from '~/models/ConstructionItemSetting';
import { generatePath } from '~/utils/generatePath';

export const buildIndexPath = (companyMasterId: number): string =>
  queryString.stringifyUrl({
    url: generatePath('/vendors/construction_item_settings'),
    query: { company_master_id: companyMasterId }
  });

export const useConstructionItemSettings = (
  companyMasterId: number
): SwrReturnType<ConstructionItemSettingEdit[]> => {
  const { data, mutate, error, isLoading } = useSWR<
    ConstructionItemSettingEdit[]
  >(buildIndexPath(companyMasterId));

  return {
    data: data ?? null,
    mutate,
    isLoading,
    error
  };
};
